<div
  class="flex-container overflow-hidden"
  [class.profile-mode]="profileMode"
  [class.loading]="isLoading"
>
  <div class="modal-body">
    <form [formGroup]="formUser">
      <div class="user-fields-wrapper mb-3">
        <div class="mb-3" *ngIf="!profileMode">
          <div class="standart-text title mb-1">
            {{
              editableUser
                ? 'Edit User Information'
                : 'Enter New User Information'
            }}
          </div>
          <div>
            <span class="standart-text-required-symbol">* </span>
            <span>Fields are required</span>
          </div>
        </div>

        <div>
          <div class="input-label">
            <span class="standart-text-required-symbol">* </span>
            Login
          </div>

          <input
            type="email"
            placeholder="Enter Email"
            class="input"
            formControlName="userName"
            [class.is-invalid]="
              formUser.get('userName')?.touched &&
              formUser.get('userName')?.invalid
            "
          />

          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('userName')?.invalid &&
              formUser.get('userName')?.touched
            "
          >
            <span *ngIf="formUser.get('userName')?.errors?.required"
              >This field is required</span
            >
            <span *ngIf="formUser.get('userName')?.errors?.pattern"
              >Must be email format like: 'example&#64;mail.com'
            </span>
          </div>
        </div>

        <div>
          <div class="input-label">
            <span class="standart-text-required-symbol">* </span>
            First Name
          </div>
          <input
            type="text"
            placeholder="Enter First Name"
            class="input"
            formControlName="firstName"
            autocomplete="first name"
            [class.is-invalid]="
              formUser.get('firstName')?.touched &&
              formUser.get('firstName')?.invalid
            "
          />

          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('firstName')?.invalid &&
              formUser.get('firstName')?.touched
            "
          >
            <span *ngIf="formUser.get('firstName')?.errors?.required"
              >This field is required</span
            >
            <span *ngIf="formUser.get('firstName')?.errors?.maxlength"
              >Maximum length is
              {{
                formUser.get('firstName')?.errors?.maxlength['requiredLength']
              }}
              characters.
            </span>
          </div>
        </div>

        <div>
          <div class="input-label">
            <span class="standart-text-required-symbol">* </span>
            Last Name
          </div>
          <input
            type="text"
            placeholder="Enter Last Name"
            class="input"
            formControlName="lastName"
            autocomplete="last name"
            [class.is-invalid]="
              formUser.get('lastName')?.touched &&
              formUser.get('lastName')?.invalid
            "
          />

          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('lastName')?.invalid &&
              formUser.get('lastName')?.touched
            "
          >
            <span *ngIf="formUser.get('lastName')?.errors?.required"
              >This field is required</span
            >
            <span *ngIf="formUser.get('lastName')?.errors?.maxlength"
              >Maximum length is
              {{
                formUser.get('lastName')?.errors?.maxlength['requiredLength']
              }}
              characters.
            </span>
          </div>
        </div>

        <div>
          <div class="input-label">Case Number</div>
          <input
            type="text"
            placeholder="Enter Case Number"
            class="input"
            formControlName="caseNumber"
            maxlength="25"
            [class.is-invalid]="
              formUser.get('caseNumber')?.touched &&
              formUser.get('caseNumber')?.invalid
            "
          />

          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('caseNumber')?.invalid &&
              formUser.get('caseNumber')?.touched
            "
          >
            <div *ngIf="formUser.get('caseNumber')?.errors?.maxlength">
              <div>The maximum length allowed is 25 characters.</div>
              <div>
                Actual length is:
                {{ formUser.get('caseNumber')?.errors?.maxlength.actualLength }}
                characters.
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="input-label">
            <span class="standart-text-required-symbol">* </span>
            Phone
          </div>
          <input
            type="text"
            placeholder="Enter Phone"
            class="input"
            formControlName="phone"
            autocomplete="phone"
            mask="(000) 000-0000"
            [class.is-invalid]="
              formUser.get('phone')?.touched && formUser.get('phone')?.invalid
            "
          />

          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('phone')?.invalid && formUser.get('phone')?.touched
            "
          >
            <span *ngIf="formUser.get('phone')?.errors?.required"
              >This field is required</span
            >
            <span *ngIf="formUser.get('phone')?.errors?.maxlength"
              >Maximum length is
              {{ formUser.get('phone')?.errors?.maxlength['requiredLength'] }}
              characters.
            </span>
            <div *ngIf="formUser.get('phone')?.errors?.mask">
              <div>
                Value should be in the next format:
                {{ formUser.get('phone')?.errors?.mask['requiredMask'] }}.
              </div>
              <div>
                Actual Value is:
                {{ formUser.get('phone')?.errors?.mask['actualValue'] }}.
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="input-label">Cell Phone</div>
          <input
            type="text"
            placeholder="Enter Cell Phone"
            class="input"
            formControlName="cellPhone"
            mask="(000) 000-0000"
            [class.is-invalid]="
              formUser.get('cellPhone')?.touched &&
              formUser.get('cellPhone')?.invalid
            "
          />

          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('cellPhone')?.invalid &&
              formUser.get('cellPhone')?.touched
            "
          >
            <div *ngIf="formUser.get('cellPhone')?.errors?.mask">
              <div>
                Value should be in the next format:
                {{ formUser.get('cellPhone')?.errors?.mask['requiredMask'] }}.
              </div>
              <div>
                Actual Value is:
                {{ formUser.get('cellPhone')?.errors?.mask['actualValue'] }}.
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="input-label">
            <span class="standart-text-required-symbol">*</span>
            User Type
          </div>
          <div
            class="input-wrap select"
            [class.is-invalid]="
              formUser.get('accessLevel')?.touched &&
              formUser.get('accessLevel')?.invalid
            "
          >
            <select
              class="input"
              formControlName="accessLevel"
              [class.is-invalid]="
                formUser.get('accessLevel')?.touched &&
                formUser.get('accessLevel')?.invalid
              "
            >
              <option [value]="''" selected="selected">Select User Type</option>
              <option
                *ngIf="isOptionAvilable('SECURE_CONNECT')"
                ngValue="SECURE_CONNECT"
              >
                Secure Connect
              </option>
              <option *ngIf="isOptionAvilable('VENDOR')" ngValue="VENDOR">
                Vendor
              </option>
              <option *ngIf="isOptionAvilable('ACCOUNT')" ngValue="ACCOUNT">
                Account
              </option>
              <option
                *ngIf="isOptionAvilable('BILLING_GROUP')"
                ngValue="BILLING_GROUP"
              >
                BillingGroup
              </option>
            </select>
          </div>
          <div
            class="invalid-feedback text-left"
            *ngIf="
              formUser.get('accessLevel')?.invalid &&
              formUser.get('accessLevel')?.touched
            "
          >
            <span *ngIf="formUser.get('accessLevel')?.errors?.required"
              >This field is required</span
            >
          </div>
        </div>
      </div>

      <div class="form-row md mb-3">
        <div
          class="d-flex align-items-start"
          [class.col-12]="!profileMode"
          [class.col-6]="profileMode"
        >
          <div class="mw-68px mr-3">
            <div class="input-label">
              <span class="standart-text-required-symbol">* </span>
              Pin
            </div>
            <input
              type="text"
              placeholder="Pin"
              class="input"
              formControlName="pin"
              mask="0{4}"
              [class.is-invalid]="
                formUser.get('pin')?.touched && formUser.get('pin')?.invalid
              "
            />
          </div>
          <div class="d-flex pt-3 mt-1">
            <label class="checkbox mr-3">
              <input type="checkbox" formControlName="active" />
              <span>Active</span>
            </label>

            <label class="checkbox">
              <input type="checkbox" formControlName="passwordResetAllowed" />
              <span>Password Reset Allowed</span>
            </label>
          </div>
        </div>

        <div class="col-6" *ngIf="profileMode">
          <div class="input-label">
            <span class="standart-text-required-symbol">* </span>
            User Permission
          </div>
          <ng-select
            [items]="permissions"
            [multiple]="true"
            bindLabel="name"
            [closeOnSelect]="false"
            placeholder="Choose a permission(s)"
            appendTo="body"
            formControlName="permissions"
            [class.is-invalid]="
              formUser.get('permissions')?.touched &&
              formUser.get('permissions')?.invalid
            "
          >
          </ng-select>
        </div>

        <div
          class="invalid-feedback d-block text-left col-12"
          *ngIf="formUser.get('pin')?.invalid && formUser.get('pin')?.touched"
        >
          <span *ngIf="formUser.get('pin')?.errors?.required"
            >This field is required</span
          >
          <span *ngIf="formUser.get('pin')?.errors?.maxlength?.requiredLength">
            Pin length must be
            {{ formUser.get('pin')?.errors?.maxlength?.requiredLength }}
            characters
          </span>
          <span *ngIf="formUser.get('pin')?.errors?.minlength?.requiredLength">
            Pin length must be
            {{ formUser.get('pin')?.errors?.minlength?.requiredLength }}
            characters
          </span>
        </div>
      </div>

      <div class="form-row md mt-3 mb-3" *ngIf="!profileMode">
        <div class="col-12">
          <div class="input-label">
            <span class="standart-text-required-symbol">* </span>
            User Permission
          </div>
        </div>
        <div class="col-6">
          <ng-select
            [items]="permissions"
            [multiple]="true"
            bindLabel="name"
            [closeOnSelect]="false"
            placeholder="Choose a permission(s)"
            appendTo="body"
            formControlName="permissions"
            [class.is-invalid]="
              formUser.get('permissions')?.touched &&
              formUser.get('permissions')?.invalid
            "
          >
          </ng-select>
        </div>
        <div class="col-6 d-flex align-items-center">
          <a
            href="javascript:void(0);"
            (click)="copyUserPermissions()"
            class="add-group-btn"
          >
            <i class="fas fa-copy fz-16 mr-2"></i>
            <span>Copy Permissions from existing user</span>
          </a>
        </div>

        <div
          class="col-12 invalid-feedback d-block text-left"
          *ngIf="
            formUser.get('permissions')?.invalid &&
            formUser.get('permissions')?.touched
          "
        >
          <span *ngIf="formUser.get('permissions')?.errors?.required"
            >This field is required</span
          >
        </div>
      </div>

      <div class="mt-3 pt-2" *ngIf="isUserTypeSelected">
        <div class="d-flex align-items-center mb-2">
          <div class="input-label">
            <span
              class="standart-text-required-symbol"
              *ngIf="isAdditionalDataRequired.vendors"
              >*
            </span>
            Vendors
          </div>

          <a
            href="javascript:void(0);"
            *ngIf="!profileMode"
            class="standart-link-action ml-auto"
            (click)="addApplication()"
          >
            <i class="fas fa-search"></i>
          </a>
        </div>

        <div
          class="user-modal-table"
          *ngIf="userVendors?.length; else emptyVendors"
        >
          <table class="standart-table">
            <thead class="standart-table-header">
              <tr>
                <th style="width: 70%">name</th>
                <th style="width: 30%">code</th>
                <th class="actions-cell"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vendor of userVendors">
                <td class="no-wrap">{{ vendor?.description || 'N/A' }}</td>
                <td>{{ vendor?.code || 'N/A' }}</td>
                <td class="actions-cell">
                  <div class="d-flex justify-content-end">
                    <a
                      href="javascript:void(0);"
                      class="standart-link-action red"
                      [class.disabled]="profileMode"
                      (click)="removeApplication(vendor)"
                    >
                      <i class="fas fa-times-circle"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-3 pt-2" *ngIf="userVendors?.length || profileMode">
        <div class="d-flex align-items-center mb-2">
          <div class="input-label">
            <span
              class="standart-text-required-symbol"
              *ngIf="isAdditionalDataRequired.accounts"
              >*
            </span>
            Accounts
          </div>

          <a
            href="javascript:void(0);"
            *ngIf="!profileMode"
            class="standart-link-action ml-auto"
            (click)="addAccountModal()"
          >
            <i class="fas fa-search"></i>
          </a>
        </div>

        <accounts-to-user-grid
          [disabled]="profileMode"
          [isUserEdit]="isEditMode"
          [profileMode]="profileMode"
          [userApplications]="userVendors"
          [userAccounts]="userAccounts"
          (accountsApplay)="setAccountsToUser($event)"
          (accountsCheck)="setCheckedAccounts($event)"
        >
        </accounts-to-user-grid>
      </div>

      <div class="mt-3 pt-2" *ngIf="userAccounts?.length || profileMode">
        <div class="d-flex align-items-center mb-2">
          <div class="input-label">
            <span
              class="standart-text-required-symbol"
              *ngIf="isAdditionalDataRequired.groups"
              >*
            </span>
            Groups
          </div>

          <a
            href="javascript:void(0);"
            [class.disabled]="profileMode"
            (click)="copyUserGroups()"
            title="Copy Groups from existing user"
            class="add-group-btn mr-3 ml-auto"
          >
            <i class="fas fa-copy fz-16"></i>
          </a>

          <a
            href="javascript:void(0);"
            *ngIf="!profileMode"
            class="standart-link-action"
            (click)="addGroupModal()"
          >
            <i class="fas fa-search"></i>
          </a>
        </div>

        <add-group-to-user-grid
          [disabled]="profileMode"
          [isUserEdit]="isEditMode"
          [profileMode]="profileMode"
          [userGroups]="userGroups"
          [userAccounts]="userAccounts"
          (groupsApplay)="setGroupsToUser($event)"
          (groupsCheck)="setCheckedGroups($event)"
        >
        </add-group-to-user-grid>
      </div>
    </form>
  </div>

  <div class="modal-footer" *ngIf="!profileMode">
    <button
      class="button w-134px ml-auto"
      [disabled]="formUser.invalid || !isAdditionalDataValid"
      (click)="onSubmit()"
    >
      Save & Close
    </button>
  </div>
</div>

<ng-template #emptyVendors>
  <empty-state
    size="sm"
    title="No Vendor(s) Yet"
    [text]="
      'You can add a vendor by clicking the \<i class=\'fas fa-plus-circle\'>\</i> button above'
    "
  >
  </empty-state>
</ng-template>
